import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('MEDIA_COMMENTS_MODERATION').plugin(axiosPlugin, {template: "array"});

let fetchMediaCommentsModerationAction = redux.fetchActionGet();

export const fetchMediaCommentsModeration = (query = {}) => fetchMediaCommentsModerationAction(`/users/me/moderation-comments/medias?${queryString.stringify(query)}`);
export const resetMediaCommentsModeration = () => redux.actions.reset();

export const mediaCommentsModeration = redux.reducer();